import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconStageMode({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M3 0h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm0 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H3zm0 8.5a.5.5 0 0 1 1 0v1.793l1.707-1.707a.5.5 0 0 1 .707.707L4.707 12H6.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3zM12.5 7a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h1.793L9.586 5.707a.5.5 0 0 0 .707.707L12 4.707V6.5a.5.5 0 0 0 .5.5z"/>
        </svg>
    );
}

export default IconStageMode;
